import ControllerBase from '../../../../global/js/ControllerBase';


enum SubmitButtonUseCases {
    Disable,
    Enable,
    Done
}

export default class ControllerAhuRequest extends ControllerBase {
    private readonly componentRefs = {
        formWrapper: 'formFinderWrapper',
        submitBtn: 'submitBtn',
        spinnerWrapper: 'spinnerWrapper',
        submitText: 'submitText',
        doneWrapper: 'doneWrapper'
    };
    constructor(element: HTMLElement) {
        super(element);
        this.observeFormSubmissions();
    }


    /**
     * Returns the form html element
     * @returns HTMLFormElement
     */
    private getForm(): HTMLFormElement | undefined {
        const form = <HTMLFormElement>(this.$references[this.componentRefs.formWrapper]);
        if (form) {
            return form;
        }
    }

    private getSubmitButton(): HTMLElement | undefined {
        const submitBtn = <HTMLElement>(this.$references[this.componentRefs.submitBtn]);
        if (submitBtn) {
            return submitBtn;
        }
    }

    private getSpinnerWrapper(): HTMLElement | undefined {
        const spinnerWrapper = <HTMLElement>(this.$references[this.componentRefs.spinnerWrapper]);
        if (spinnerWrapper) {
            return spinnerWrapper;
        }
    }

    private getSubmitText(): HTMLElement | undefined {
        const submitText = <HTMLElement>(this.$references[this.componentRefs.submitText]);
        if (submitText) {
            return submitText;
        }
    }

    private getDoneWrapper(): HTMLElement | undefined {
        const doneWrapper = <HTMLElement>(this.$references[this.componentRefs.doneWrapper]);
        if (doneWrapper) {
            return doneWrapper;
        }
    }

    /**
     * Watch for form submitted events
     * @returns void
     */
    private observeFormSubmissions(): void {
        const form = this.getForm();

        if (form) {
            form.addEventListener("submit", (evt) => {

               this.handleDisableSubmitButton(SubmitButtonUseCases.Disable)
                //after 30 secs reanable it
                setTimeout(() => this.handleDisableSubmitButton(SubmitButtonUseCases.Enable), 30000);
            });
        }
    }


    private handleDisableSubmitButton(disable: SubmitButtonUseCases) {
        const submitBtn = this.getSubmitButton();
        const spinnerWrapper = this.getSpinnerWrapper();
        const submitText = this.getSubmitText();
        const doneWrapper = this.getDoneWrapper();
        switch (disable) {
            case SubmitButtonUseCases.Disable:
                submitBtn?.setAttribute('disabled', 'disabled');
                spinnerWrapper?.setAttribute("style", "display: unset;");
                submitText?.setAttribute("style", "display: none;");
                break;
            case SubmitButtonUseCases.Enable:
                submitBtn?.removeAttribute('disabled');
                spinnerWrapper?.setAttribute("style", "display: none;");
                submitText?.setAttribute("style", "display: block;");
                break
            case SubmitButtonUseCases.Done:
                submitBtn?.setAttribute('disabled', 'disabled');
                spinnerWrapper?.setAttribute("style", "display: none;");
                submitText?.setAttribute("style", "display: none;");
                doneWrapper?.setAttribute("style", "display: unset;");
                break;

        }

    }

}
